var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavRehabilitation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5104 3.11354C25.8439 4.46647 26.593 6.30139 26.593 8.21466C26.593 10.1279 25.8439 11.9628 24.5104 13.3158L24.0374 13.7978L13.9815 24L3.4494 13.3158C2.11615 11.9625 1.36719 10.1275 1.36719 8.21414C1.36719 6.30079 2.11615 4.46575 3.4494 3.11251V3.11251C4.78325 1.75986 6.59197 1 8.47789 1C10.3638 1 12.1725 1.75986 13.5064 3.11251L13.9815 3.59346L14.4545 3.11457C15.1147 2.44444 15.8987 1.91284 16.7615 1.55015C17.6243 1.18746 18.549 1.00078 19.483 1.00078C20.4169 1.00078 21.3417 1.18746 22.2045 1.55015C23.0673 1.91284 23.8512 2.44444 24.5115 3.11457L24.5104 3.11354Z",
    stroke: "#27BDBE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9766 5.02502V3.59351",
    stroke: "#27BDBE",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9766 24V18.3379",
    stroke: "#27BDBE",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9766 14.1053V11.1442V9.25757",
    stroke: "#27BDBE",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5156 11.1443H13.9836H18.1636",
    stroke: "#27BDBE",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7998 11.1443H22.3359",
    stroke: "#27BDBE",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33872 11.1443H1.97656",
    stroke: "#27BDBE",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.98 9.25651C13.6408 9.39055 13.2745 9.43861 12.9128 9.39655C12.5512 9.35449 12.2051 9.22356 11.9046 9.01512C11.6041 8.80669 11.3583 8.52703 11.1884 8.2004C11.0185 7.87377 10.9297 7.51004 10.9297 7.14072C10.9297 6.77141 11.0185 6.40767 11.1884 6.08104C11.3583 5.75441 11.6041 5.47476 11.9046 5.26632C12.2051 5.05788 12.5512 4.92696 12.9128 4.88489C13.2745 4.84283 13.6408 4.8909 13.98 5.02493",
    stroke: "#27BDBE",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.511 11.1443C10.6431 11.4884 10.6905 11.8601 10.649 12.227C10.6076 12.5939 10.4785 12.945 10.2731 13.2499C10.0676 13.5547 9.79198 13.8042 9.47003 13.9765C9.14809 14.1489 8.78957 14.239 8.42555 14.239C8.06153 14.239 7.70301 14.1489 7.38106 13.9765C7.05912 13.8042 6.78347 13.5547 6.57802 13.2499C6.37257 12.945 6.24353 12.5939 6.20206 12.227C6.1606 11.8601 6.20798 11.4884 6.34009 11.1443",
    stroke: "#27BDBE",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1604 11.1442C18.0283 10.8001 17.9809 10.4285 18.0224 10.0615C18.0638 9.69464 18.1929 9.34353 18.3983 9.03866C18.6038 8.73379 18.8794 8.48436 19.2014 8.312C19.5233 8.13964 19.8818 8.04956 20.2459 8.04956C20.6099 8.04956 20.9684 8.13964 21.2903 8.312C21.6123 8.48436 21.8879 8.73379 22.0934 9.03866C22.2988 9.34353 22.4279 9.69464 22.4693 10.0615C22.5108 10.4285 22.4634 10.8001 22.3313 11.1442",
    stroke: "#27BDBE",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9844 14.1075C14.3236 13.9734 14.6899 13.9253 15.0515 13.9674C15.4132 14.0095 15.7593 14.1404 16.0598 14.3488C16.3603 14.5573 16.6061 14.8369 16.776 15.1636C16.9459 15.4902 17.0347 15.8539 17.0347 16.2232C17.0347 16.5926 16.9459 16.9563 16.776 17.2829C16.6061 17.6096 16.3603 17.8892 16.0598 18.0976C15.7593 18.3061 15.4132 18.437 15.0515 18.4791C14.6899 18.5211 14.3236 18.4731 13.9844 18.339",
    stroke: "#27BDBE",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavRehabilitation);
export default __webpack_public_path__ + "static/media/nav-rehabilitation.2c9f02eb708ac7fe0b189948df78fe4d.svg";
export { ForwardRef as ReactComponent };